import React from "react";
import { Component } from "react";


export default class AuthenticationSlider extends Component {

    state = {}

    componentDidMount() {}

    render() {
        return (
            <div className="h-100 position-relative">
                <div className="h-100 w-100">
                    {Array.isArray(this.props.children) && this.props.children.map((child, index) => {
                        if (index == this.props.active)
                            return (
                                <div key={index} className="h-100 w-100">
                                    {child}
                                </div>
                            )
                    })}
                </div>
                {this.props.buttons && (
                    <div className="w-100" style={{ position: 'absolute', bottom: 10 }}>
                        <div className="flexcb mx-3">
                            <div className=''>
                                <button name="previous " className="flexcc" style={{}} onClick={() => this.props.handleClick(-1)}>
                                    <img width={40} src="/assets/icons/arrow.left.svg" />
                                </button>
                            </div>
                            <div style={{ justifyContent: 'right' }}>
                                {this.props.children.map((item, index) => {
                                    return (
                                        <div key={index} className="circle" style={{ opacity: this.props.active == index ? 1 : 0.5 }}></div>
                                    )
                                })}
                            </div>
                            <div>
                                <button name="next" className="flexcc" style={{}} onClick={() => this.props.handleClick()}>
                                    <img width={40} src="/assets/icons/arrow.right.svg" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

}